// extracted by mini-css-extract-plugin
export var cardUser = "CardUser_cardUser__Ai3Q8";
export var imgAvatarWrapper = "CardUser_imgAvatarWrapper__RTuE4";
export var infoWrapper = "CardUser_infoWrapper__v98bx";
export var imgAspectRatioContainer = "CardUser_imgAspectRatioContainer__iLO0e";
export var imgCover = "CardUser_imgCover__ZQDY7";
export var imgAvatar = "CardUser_imgAvatar__9Ecpr";
export var textName = "CardUser_textName__dR06f";
export var rotate = "CardUser_rotate__yGZiW";
export var dotty = "CardUser_dotty__4BNk7";